<template>
    <v-card
        class="mx-auto"
        elevation="0"
    >
      <v-card-title class="card-header-add fixed-card-title">
        <v-row dense>
          <v-col class="d-flex align-center justify-start" cols="10">
            {{$t('view-licence')}}
          </v-col>
          <v-col cols="2" class="d-flex align-center justify-end">
            <v-icon v-if="roleName === 'SYSTEM_ADMIN'" @click="syncronizeDrawers"  color="white" class="mr-2">mdi-pencil</v-icon>
            <v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-container class="mt-16 overflow-y-hidden">
        <v-card class="pa-5">
          <div class="text-left">
            <span>{{$t('license-name')}}: </span> {{selectedLicense?.licenseName}}
          </div>
          <div class="text-left">
            <span>{{$t('license-type')}}:  </span>  {{selectedLicense?.licenseType}}
          </div>
            <div class="text-left">
           <span>{{$t('license-description')}}: </span> {{selectedLicense?.licenseDescription}}
            </div>
          <div class="text-left">
            <span>{{$t('license-price')}} : </span> {{selectedLicense?.price}}
          </div>
          <div class="text-left">
            <span>{{$t('license-status')}}: </span> {{selectedLicense?.isActive ? $t('active') : $t('inactive')}}
          </div>
          <div class="text-left">
            <span>{{$t('license-assigned')}}: </span> {{selectedLicense?.isLicenseAssigned ? $t('assigned') : $t('not-assigned')}}
          </div>
          <div class="text-left" v-if="selectedLicense?.isLicenseAssigned">
            <div class="text-left">
              <span>{{$t('patient-name')}}: </span> {{selectedLicense?.patientName}}
            </div>
            <div class="text-left">
              <span>{{$t('location-name')}}: </span> {{selectedLicense?.officeName}}
            </div>
          </div>
        </v-card>
      </v-container>
      <div v-if="selectedLicense?.licenseAssignments.length >=1" class="text-left pl-4">
        <span class="font-weight-bold">{{$t('assignments')}}</span>
      </div>
      <div class="overflow-auto" style="height:630px;">
        <v-card  elevation="5" class="pa-3 ma-3" v-for="(licence , index) in selectedLicense?.licenseAssignments" :key="index" >
          <v-img class="ml-auto" max-width="20" min-width="20" :src="licenceIcon"></v-img>
          <div class="text-left">
            <v-row dense>
              <v-col cols="6" class="text-left d-flex align-center">
                <v-img class="mr-1" max-width="20" min-width="20" :src="hospital"></v-img>
                <span class="font-weight-medium font-size14">{{$t('hospital')}}</span>
              </v-col>
              <v-col cols="6" class="text-right">
                <span class="font-weight-medium font-size14">{{ licence?.officeName }}</span>
              </v-col>
            </v-row>
          </div>

          <div class="text-left">
            <v-row dense>
              <v-col cols="6" class="text-left d-flex align-center">
                <v-img class="mr-1" max-width="14" min-width="14" :src="patientBlack"></v-img>
                <span class="font-weight-medium font-size14">{{$t('patient')}}</span>
              </v-col>
              <v-col cols="6" class="text-right">
                <span class="font-weight-medium font-size14"> {{ licence?.patientName }}</span>
              </v-col>
            </v-row>
          </div>

          <div class="text-left">
            <v-row dense>
              <v-col cols="6" class="text-left d-flex align-center">
                <v-img class="mr-1" max-width="14" min-width="14" :src="doctorBlack"></v-img>
                <span class="font-weight-medium font-size14">{{$t('licence-assigned')}}</span>
              </v-col>
              <v-col cols="6" class="text-right">
                <span class="font-weight-medium font-size14">{{ licence?.assignByStaffName }}</span>
              </v-col>
            </v-row>
          </div>

          <div class="text-left" v-if="licence?.deAssignByStaffName !== null">
            <v-row dense>
              <v-col cols="6" class="text-left d-flex align-center">
                <v-img class="mr-1" max-width="14" min-width="14" :src="doctorBlack"></v-img>
                <span class="font-weight-medium font-size14">{{$t('licence-deassigned')}}</span>
              </v-col>
              <v-col cols="6" class="text-right">
                <span class="font-weight-medium font-size14">{{ licence?.deAssignByStaffName }}</span>
              </v-col>
            </v-row>
          </div>

          <div class="text-left">
            <v-row dense>
              <v-col cols="6" class="text-left d-flex align-center">
                <span class="font-weight-medium font-size14">{{$t('end-date')}}: {{ licence?.startingAt !== null ? formattedDateTime(licence?.startingAt, 'date_med') :  '' }}</span>
              </v-col>
              <v-col cols="6" class="text-right">
                <span class="font-weight-medium font-size14">{{ licence?.expiresAt !== null ? $t('end-date') + ": " + formattedDateTime(licence?.expiresAt, 'date_med') : $t('active') }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>

    </v-card>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { doctorBlack, hospitalBlack, patientBlack, licenceBlack } from '@/assets';
import { formattedDateTime } from '../../utils/luxon-formater';

export default {
  name: 'ViewLicense.vue',
  data () {
    return {
      hospital: hospitalBlack,
      showLicences: false,
      licenceIcon: licenceBlack,
    };
  },
  computed: {
    doctorBlack () {
      return doctorBlack;
    },
    patientBlack () {
      return patientBlack;
    },
    ...mapState({
      selectedLicense: (state) => state.licenses.selectedLicense,
    }),
    ...mapGetters({
      pageHeight: 'pageHeight',
      roleName: 'authentication/getRole',
    }),
    headers () {
      const headers = [
        {
          text: this.$t('patient-name'),
          value: 'status',
          class: 'table-header',
          align: 'start pl-3',
        },
        {
          text: this.$t('officeName'),
          value: 'fullName',
          class: 'table-header',
          align: 'start pl-3',
        },
        {
          text: this.$t('assignByStaffName'),
          value: '',
          class: 'table-header pl-1',
          sortable: false,
        },
      ];
      return headers;
    },
  },
  methods: {
    formattedDateTime,
    closeDrawer () {
      this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
    },
    syncronizeDrawers () {
      this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
        updateDrawer: true,
        page2: 'licence',
        item: this.selectedLicense,
      });
    },
  },
};
</script>
<style scoped></style>
